module.exports = new __parcel__URL__("undertale.3881d813.jpg").toString();